'use client';

import Image from 'next/image';
import type React from 'react';

interface LogoSvgProps {
  colorMode?: 'light' | 'dark' | 'all-light';
  className?: string;
}

const LogoSvg: React.FC<LogoSvgProps> = ({ colorMode = 'light', className = '' }) => {
  const appName = process.env.NEXT_PUBLIC_APP_NAME || '';
  return (
    <div
      className={`relative inline-flex justify-start relative w-auto h-full transition-all aspect-auto duration-300 hover:scale-105 ${className}`}
    >
      {/* Light mode logo */}
      <Image
        src='/logo/header-logo-white-text.svg'
        alt={appName}
        width={500}
        height={226}
        style={{ objectFit: 'contain' }}
        className={`absolute w-auto h-full transition-opacity duration-300 ease-in-out ${
          colorMode === 'light' ? 'opacity-100' : 'opacity-0'
        }`}
      />

      {/* Dark mode logo */}
      <Image
        src='/logo/header-logo-dark-text.svg'
        alt={appName}
        width={500}
        height={226}
        style={{ objectFit: 'contain' }}
        className={`absolute w-auto h-full transition-opacity duration-300 ease-in-out ${
          colorMode === 'dark' ? 'opacity-100' : 'opacity-0'
        }`}
      />

      {/* All-light mode logo */}
      <Image
        src='/logo/footer-logo.svg'
        alt={appName}
        width={500}
        height={226}
        style={{ objectFit: 'contain' }}
        className={`w-full h-full transition-opacity duration-300 ease-in-out ${
          colorMode === 'all-light' ? 'opacity-100' : 'opacity-0'
        }`}
      />
    </div>
  );
};

export default LogoSvg;
